import { type SxProps, type Theme } from '@mui/material'

export const styles = {
  container: {
    mt: 2,
    p: 2,
    borderColor: 'grey-100',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  } satisfies SxProps<Theme>,
  contentWrapper: {
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden'
  } satisfies SxProps<Theme>,
  icon: {
    mr: 1,
    flexShrink: 0
  } satisfies SxProps<Theme>,
  link: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  } satisfies SxProps<Theme>
}
